import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_auth/_side-layout/super-admin/visitor-id/',
)({
  beforeLoad: () => {
    throw redirect({ to: '/super-admin/visitor-id/configuration' });
  },
});
